import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { disconnect } from '../../../base/connection';
import { InlineDialogWithoutAnalytics } from '../../../base/react/components/web/InlineDialog';
import { toggleHangUpSettings } from '../../../settings';


import { HangupContent } from './HangupContent';

type Props = {
    children: React$Node,
}


/**
 * FUnction Object.
 *
 * @param {any} props - Props.
 * @returns {any}
 */
export default function HangUpSettingsPopup(props: Props) {
    const { hangupSettingsVisible: isOpen } = useSelector(state => state['features/settings']);
    const dispatch = useDispatch();
    const onClose = () => dispatch(toggleHangUpSettings());
    const partipicipantss = useSelector(state => state['features/base/participants']);
    const isRemoteParticipants = partipicipantss.filter(it => it.local !== true) ?? [];
    const [ isLeaving, setIsleaving ] = React.useState(false);

    React.useEffect(() => {
        if (isRemoteParticipants.length === 0 && isLeaving) {
            dispatch(disconnect(false));
        }
    }, [ isLeaving, isRemoteParticipants?.length ]);

    return (
        <div className = 'hangup-settings-popup'>
            <InlineDialogWithoutAnalytics
                content = { <HangupContent onLeaveEveryOne = { setIsleaving } /> }
                isOpen = { isOpen }
                onClose = { onClose }
                placement = 'top'>
                <span className = 'hangup-settings-trigger'>
                    {props.children}
                </span>
            </InlineDialogWithoutAnalytics>

        </div>
    );
}
